import classNames from "classnames"
import React from "react"

const Tabs = ({ variant = "primary", useItemVariants = false, selected, setSelected, items }) => {
  return (
    <div className={"tabs"}>
      {items.map(({ value, label, variant: itemVariant }) => (
        <button
          key={value}
          className={classNames(`tabs__item`, {
            selected: value === selected,
            "tabs__item--primary": useItemVariants ? itemVariant === "primary" : variant === "primary",
            "tabs__item--secondary": useItemVariants ? itemVariant === "secondary" : variant === "secondary",
          })}
          onClick={() => setSelected(value)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default Tabs
